import IdCardButton from './IdCardButton';
import IdCardButtonEE from './IdCardButtonEE';
import SmartIdButton from './SmartIdButton';
import MobileIdButton from './MobileIdButton';
import MobileIdButtonEE from './MobileIdButtonEE';
import EparakstsMobileButton from './EparakstsMobileButton';
import EparakstsSmartCardButton from './EparakstsSmartCardButton';
import FrejaEidButton from './FrejaEidButton';
import ZealIdButton from './ZealIdButton';
import IdCardButtonBe from './IdCardButtonBe';
import MojeIdButton from './MojeIdButton';
import FinnishTrustNetworkButton from './FinnishTrustNetworkButton';
import AtHandyButton from './AtHandyButton';
import IdCardButtonFi from './IdCardButtonFi';
import IdCardButtonLv from './IdCardButtonLv';
import IdCardButtonPt from './IdCardButtonPt';
import OtpButton from './OtpButton';
import GoogleButton from './GoogleButton';
import EvrotrustButton from './EvrotrustButton';
import BankIdButton from './BankIdButton';
import DTrustSignMeButton from './DTrustSignMeButton';
import MitIdButton from './MitIdButton';
import ChaveMovelButton from './ChaveMovelButton';
import NoBankIdButton from './NoBankIdButton';
import ItsmeButton from './ItsmeButton';
import CertEuropeUsbButton from './CertEuropeUsbButton';
import CertSignUsbButton from './CertSignUsbButton';
import IdinButton from './IdinButton';
import VerifaiButton from './VerifaiButton';
import SpidButton from './SpidButton';
import FinnishTrustNetworkAdvancedFullButton from './FinnishTrustNetworkAdvancedFullButton';
import AudkenniButton from './AudkenniButton';
import YesComButton from './YesComButton';
import EdoAppEidButton from "./EdoAppEidButton";
import SimplySignButton from "./SimplySignButton";

const methodButtons = Object.freeze({
  IdCardButton,
  IdCardButtonEE,
  SmartIdButton,
  MobileIdButton,
  MobileIdButtonEE,
  EparakstsMobileButton,
  FrejaEidButton,
  ZealIdButton,
  IdCardButtonBe,
  MojeIdButton,
  FinnishTrustNetworkButton,
  FinnishTrustNetworkAdvancedFullButton,
  AtHandyButton,
  IdCardButtonFi,
  IdCardButtonLv,
  IdCardButtonPt,
  OtpButton,
  GoogleButton,
  EvrotrustButton,
  BankIdButton,
  DTrustSignMeButton,
  MitIdButton,
  ChaveMovelButton,
  NoBankIdButton,
  ItsmeButton,
  CertEuropeUsbButton,
  CertSignUsbButton,
  IdinButton,
  VerifaiButton,
  SpidButton,
  AudkenniButton,
  EparakstsSmartCardButton,
  YesComButton,
  EdoAppEidButton,
  SimplySignButton,
});

export default methodButtons;
